import type {
  AuthV2ConfirmForgotPasswordRequest,
  AuthV2ForgotPasswordRequest,
  AuthV2LoginRequest,
  AuthV2RespondChallengeRequest,
  Configuration,
} from '@repo/api-gw-sdk';
import {
  AuthV2ConfirmForgotPasswordApi,
  AuthV2ForgotPasswordApi,
  AuthV2LoginApi,
  AuthV2RespondChallengeApi,
} from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

export const authV2 = (httpClient: HttpClient, config: Configuration) => {
  const loginApi = new AuthV2LoginApi(config);
  const respondChallengeApi = new AuthV2RespondChallengeApi(config);
  const forgotPasswordApi = new AuthV2ForgotPasswordApi(config);
  const confirmForgotPasswordApi = new AuthV2ConfirmForgotPasswordApi(config);

  // `domain` is a dev-only tenant override (the backend honors it only in local
  // environments, where there is no tenant subdomain). It is undefined in real
  // environments, where the tenant is resolved from the host.
  return {
    login: (body: AuthV2LoginRequest, domain?: string) =>
      loginApi.authV2Login(body, domain),
    respondChallenge: (body: AuthV2RespondChallengeRequest, domain?: string) =>
      respondChallengeApi.authV2RespondChallenge(body, domain),
    forgotPassword: (body: AuthV2ForgotPasswordRequest) =>
      forgotPasswordApi.authV2ForgotPassword(body),
    confirmForgotPassword: (body: AuthV2ConfirmForgotPasswordRequest) =>
      confirmForgotPasswordApi.authV2ConfirmForgotPassword(body),
  };
};
